export default "__VITE_ASSET__$ljWLcFd__"